import { Controller } from "@hotwired/stimulus"
import growfield from 'growfield'

export default class extends Controller {
  connect () {
    this.bind_autogrow();
  }

  bind_autogrow() {
    growfield(this.element);
  }

  disconnect() {
  }
};
